<template>
  <!--  Priorities for banner content: 1. Sitewide Sale, 2. PPTO, 3. Existing user level promotion  -->
  <div id="promo-banner" class="promo-banner">
    <Banner v-if="promoCallIndex">
      <Transition name="slide-fade">
        <p v-if="activeBanner === 1">
          <span
            v-if="showPPTO && firstPptoOrder"
            class="hide-for-small-only inline"
          >
            <span v-if="firstPptoOrder.is_as_you_go">
              Spend
              <Price :amt="firstPptoOrder.remaining_amount_for_free_shipping" />
              more by {{ asYouGoPlaceBy }} to get ground shipping included.
            </span>
            <span v-else>
              You have {{ firstPptoOrder.ppto_slots_available }} slots left in
              your {{ pptoPlaceBy }}order.
            </span>
            <nuxt-link v-if="pptoLink" :to="pptoLink">
              <span class="underline strong"> Add wine to this order. </span>
            </nuxt-link>
          </span>
          <span class="default">
            Buy Over Time, Get Free Shipping At
            <a
              href="https://discover.wineaccess.com/introducing-a-long-awaited-new-shipping-feature/"
              target="_blank"
              >${{ metadata.settingsVars.STORE_FREE_SHIPPING_DOLLARS }}+</a
            >.</span
          >
        </p>
      </Transition>
      <Transition name="slide-fade">
        <p v-if="activeBanner === 2" v-html="firstSiteOfferDescription"></p>
      </Transition>
      <Transition name="slide-fade">
        <p v-if="activeBanner === 3" v-html="secondSiteOfferDescription"></p>
      </Transition>
      <Transition name="slide-fade">
        <p v-if="activeBanner === 4" v-html="firstUserOfferDescription"></p>
      </Transition>
      <Transition name="slide-fade">
        <p v-if="activeBanner === 5" v-html="promoCodeDescription"></p>
      </Transition>
      <Transition name="slide-fade">
        <p v-if="activeBanner === 6">
          You have {{ clubTimeRemaining }} left to join a club and get ${{
            clubCredit
          }}
          credit back
        </p>
      </Transition>
      <Transition
        v-for="(item, index) in promoMarketingMessages"
        :key="index"
        name="slide-fade"
      >
        <p v-if="activeBanner === 7 + index" v-html="item.message"></p>
      </Transition>
    </Banner>
  </div>
</template>

<script>
import Price from '#common/components/Price.vue'
import Banner from '@/components/Header/Banner'
import { mapGetters } from 'vuex'

export default {
  name: 'PromoBanner',
  components: {
    Banner,
    Price,
  },
  data() {
    return {
      activeBanner: 1,
      bannerSet: [],
      bannerSetIdx: 0,
      intervalHandle: false,
    }
  },
  computed: {
    ...mapGetters([
      'firstPptoOrder',
      'siteOffers',
      'userOffers',
      'promoCodes',
      'showPPTO',
      'pptoLink',
      'showPromoBanner',
      'cart',
      'promoMarketingMessages',
      'promoMessage',
      'clubCredit',
      'clubTimeRemaining',
      'promoCallIndex',
    ]),
    firstSiteOfferDescription() {
      if (
        this.siteOffers &&
        this.siteOffers.length > 0 &&
        this.siteOffers[0].description
      )
        return this.siteOffers[0].description
      return null
    },
    secondSiteOfferDescription() {
      if (
        this.siteOffers &&
        this.siteOffers.length > 1 &&
        this.siteOffers[1].description
      )
        return this.siteOffers[1].description
      return null
    },
    firstUserOfferDescription() {
      if (
        this.userOffers &&
        this.userOffers.length > 0 &&
        this.userOffers[0].description
      )
        return this.userOffers[0].description
      return null
    },
    promoCodeObj() {
      if (
        this.promoCodes &&
        this.promoCodes.length > 0 &&
        this.promoCodes[0].offers.length > 0
      )
        return this.promoCodes[0]
      return null
    },
    promoCodeDescription() {
      if (this.promoCodeObj) return this.promoCodeObj.offers[0].description
      return null
    },
    loggedIn() {
      return this.$auth.loggedIn
    },
    asYouGoPlaceBy() {
      if (!this.firstPptoOrder) return ''
      return this.$moment(this.firstPptoOrder.as_you_go_expire_date).format(
        'MMMM D',
      )
    },
    pptoPlaceBy() {
      if (
        !this.firstPptoOrder ||
        this.firstPptoOrder.status === 'pending_weather'
      )
        return ''
      return (
        this.$moment(this.firstPptoOrder.requested_delivery_date).format(
          'MMMM D',
        ) + ' '
      )
    },
    pptoDaysBeforeShipSuffix() {
      if (!this.firstPptoOrder) {
        return ''
      }
      return this.firstPptoOrder.days_before_shipment > 1 ? 's' : ''
    },
  },
  watch: {
    promoCallIndex(newValue, oldValue) {
      this.bannerSet = [1]
      if (
        this.siteOffers.length > 0 &&
        this.siteOffers[0] &&
        this.siteOffers[0].description &&
        (this.promoMarketingMessages.length === 0 ||
          this.userOffers.length === 0)
      ) {
        this.bannerSet.push(2)
      }
      if (
        this.siteOffers.length > 1 &&
        this.siteOffers[1] &&
        this.siteOffers[1].description &&
        this.promoMarketingMessages.length === 0 &&
        this.userOffers.length === 0
      ) {
        this.bannerSet.push(3)
      }
      if (
        this.userOffers.length > 0 &&
        this.userOffers[0] &&
        this.userOffers[0].description
      ) {
        this.bannerSet.push(4)
      }
      if (this.promoCodeObj) this.bannerSet.push(5)
      if (this.clubCredit) this.bannerSet.unshift(6)
      let idx = 0
      while (this.promoMarketingMessages.length > idx) {
        if (this.bannerSet.length >= 3) {
          break
        }
        this.bannerSet.push(7 + idx++)
      }

      // If this method is run twice for any reason
      // make sure to clear out old intervals
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle)
        this.intervalHandle = undefined
      }
      this.activeBanner = this.bannerSet[this.bannerSetIdx]
      this.intervalHandle = setInterval(() => {
        // if there is only one element in the bannerSet then
        // refuse to turn it.
        if (this.bannerSet.length <= 1) return
        this.bannerSetIdx++
        this.bannerSetIdx =
          this.bannerSetIdx >= this.bannerSet.length ? 0 : this.bannerSetIdx
        this.activeBanner = -1
        setTimeout(() => {
          this.activeBanner = this.bannerSet[this.bannerSetIdx]
        }, 0.55 * 1000) // this timeout needs to be just above the fade-leave-active css translate time.
      }, 6 * 1000)
    },
  },
  created() {
    this.metadata = useMetadata()
  },
  methods: {
    close() {
      this.$store.dispatch('closePromoBanner')
    },
  },
}
</script>
